import { API } from "app/api";
import {
  API_BASE_URL,
  LIST,
  GET,
  ADD_PROPOSAL,
  SET_PROPOSALS,
  SET_LAST_VISITED,
  SET_DRAFTS,
  GET_PROPOSALS,
  REMOVE_PROPOSAL,
  GET_PERMISSIONS
} from "./constants";

export const addProposal = params => {
  const { topicId, proposalId } = params;
  return {
    type: ADD_PROPOSAL,
    topicId,
    proposalId
  };
};

export const removeProposal = params => {
  const { topicId, proposalId } = params;
  return {
    type: REMOVE_PROPOSAL,
    topicId,
    proposalId
  };
};

export const setProposals = params => {
  const { topicId, proposals } = params;
  return {
    type: SET_PROPOSALS,
    topicId,
    proposals
  };
};

export const setDrafts = params => {
  const { topicId, drafts } = params;
  return {
    type: SET_DRAFTS,
    topicId,
    drafts
  };
};

export const fetchTopicProposals = params => {
  const { topicId } = params;
  return {
    type: GET_PROPOSALS,
    topicId
  };
};

export const fetchTopics = () => {
  const url = `${API_BASE_URL}/resources/topics/`;
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      ...LIST
    }
  };
};

export const fetchTopic = params => {
  const url = `${API_BASE_URL}/resources/topics/${params.topicId}`;
  const request = new Request(url, {
    method: "GET",
    credentials: "same-origin"
  });
  return {
    type: API,
    payload: {
      request,
      params,
      ...GET
    }
  };
};

export const setLastVisited = params => {
  const { topicId, proposalId } = params;
  return {
    type: SET_LAST_VISITED,
    topicId,
    proposalId
  };
};

// Get the permissions for the proposals of
// the current topic for the current user
export const fetchTopicPermissions = action => {
  return {
    type: GET_PERMISSIONS,
    proposals: action.data,
    topicId: action.payload.params.topicId
  };
};



// WEBPACK FOOTER //
// ./src/app/topics/actions.js